import React, { useMemo } from 'react';
import { DatePicker, Checkbox, Row, Col, Form } from 'antd';
import UtinaCard from 'components/UtinaCard';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import InputCurrency from 'components/InputCurrency';

type GuarantyResponse = any;

interface GuarantyAdditionalInfoProps {
  Guaranty?: GuarantyResponse;
}

const GuarantyAdditionalInfo: React.FC<GuarantyAdditionalInfoProps> = ({
  Guaranty,
}) => {
  const form = Form.useFormInstance();

  const currcode = useMemo(() => localStorage.getItem('currcode') ?? '', []);

  return (
    <div style={{ backgroundColor: '#FFF', padding: 10 }}>
      <Row gutter={40}>
        <Col span={24}>
          <UtinaCard level={5} comcode="section1">
            <Row gutter={40}>
              <Col span={6} style={{ marginBottom: 12 }}>
                <FormInput name="guarflagrenewal" valuePropName="checked">
                  <Checkbox />
                </FormInput>
              </Col>
              <Col span={6}>
                <FormInput
                  name="lastRenewalDate"
                  dependencies={['guarflagrenewal']}
                  rules={[
                    ({ getFieldValue }) => ({
                      required: getFieldValue('guarflagrenewal') === true,
                    }),
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} />
                </FormInput>
              </Col>

              <Col span={6}>
                <FormInput
                  name="reevaluationType"
                  dependencies={['guarflagrenewal']}
                  rules={[
                    ({ getFieldValue }) => ({
                      required: getFieldValue('guarflagrenewal') === true,
                    }),
                  ]}
                >
                  <ParListSelect allowClear parcode="TVG" />
                </FormInput>
              </Col>
              <Col span={6}>
                <FormInput
                  name="reevaluationDate"
                  dependencies={['guarflagrenewal']}
                  rules={[
                    ({ getFieldValue }) => ({
                      required: getFieldValue('guarflagrenewal') === true,
                    }),
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} />
                </FormInput>
              </Col>

              <Col span={6} style={{ marginBottom: 12 }}>
                <FormInput name="guarplaystatus" valuePropName="checked">
                  <Checkbox />
                </FormInput>
              </Col>
              <Col span={6}>
                <FormInput
                  name="guarplaydate"
                  dependencies={['guarplaystatus']}
                  rules={[
                    ({ getFieldValue }) => ({
                      required: getFieldValue('guarplaystatus') === true,
                    }),
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} />
                </FormInput>
              </Col>

              <Col lg={6}>
                <FormInput
                  name="guarupdatedvalue"
                  rules={[
                    ({ getFieldValue }) => ({
                      required: getFieldValue('guarflagrenewal') === true,
                    }),
                  ]}
                >
                  <InputCurrency col md={24} currcode={currcode} />
                </FormInput>
              </Col>
              <Col span={6}>
                <FormInput
                  name="updatedForecastEndDate"
                  dependencies={['guarflagrenewal']}
                  rules={[
                    ({ getFieldValue }) => ({
                      required: getFieldValue('guarflagrenewal') === true,
                    }),
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} />
                </FormInput>
              </Col>
            </Row>
          </UtinaCard>
        </Col>
      </Row>
    </div>
  );
};

export default GuarantyAdditionalInfo;
